import React from 'react';
import { FormControl } from '@withjoy/joykit';
import { LocationInput } from '@shared/components/LocationInput';
import { pxToRem } from '@withjoy/joykit/theme';
import { FormikProps } from 'formik';
import { PlaceToStayFormFields } from '../PlaceToStayForm.types';
import { StyledHotelInputContainer } from '../PlaceToStayComponent.styles';
import { useTranslation } from '@shared/core';
import { useFieldErrors } from '@shared/createEvent/hooks/useFieldErrors';

interface PlaceToStayHotelSearchProps
  extends Readonly<{
    formik: FormikProps<PlaceToStayFormFields>;
    loadingLocation: boolean;
    onLocationChange: (location: unknown) => void;
  }> {}

export const PlaceToStayHotelSearch: React.FC<PlaceToStayHotelSearchProps> = ({ formik, loadingLocation, onLocationChange }) => {
  const { tq } = useTranslation('placeToStayComponent');
  const getFieldErrorProps = useFieldErrors<PlaceToStayFormFields>(formik);

  const isHotelInvalid = !!formik.touched.address && !!formik.errors.address;
  const errorHotel = formik.touched.address && formik.errors.address ? formik.errors.address : undefined;

  return (
    <FormControl
      label={tq`Search for a hotel`}
      isRequired={false}
      {...getFieldErrorProps('address')}
    >
      <StyledHotelInputContainer
        isHotelInvalid={isHotelInvalid}
        errorHotel={errorHotel}
      >
        <LocationInput
          {...formik.getFieldProps('address')}
          onInputChange={val => {
            formik.setFieldValue('address', val);
            formik.setFieldValue('customAddress', val);
          }}
          onLocationOpen={() => {
            formik.setFieldTouched('address');
          }}
          onLocationChange={onLocationChange}
          includeCloseIcon={false}
          placeholder={tq`Renaissance Chelsea, New York`}
          loading={loadingLocation}
          includeMapIcon={false}
          placePredictionTypes={[]}
          allowCustomPlace={false}
          defaultValue={formik.values.address as string}
          formik={formik}
          css={{ ['input']: { fontSize: pxToRem(16) } }}
        />
      </StyledHotelInputContainer>
    </FormControl>
  );
};
